import { useRouter } from "next/router";
import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { salesRoutes } from "@nju/routes";
import { BlockContent, GeneralErrorNotification, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function OrderInProgress() {
  const router = useRouter();

  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent>
        <ClientSideOnly>
          <BlockContent spacing="xl" tone="none">
            <GeneralErrorNotification
              callback={() => {
                router.replace(salesRoutes.statusKlienta.get());
              }}
              copy="powrót"
              description="Klient jest w trakcie zamawiania usługi. Aby zamówić kolejną, musi dokończyć poprzedni zakup."
              icon="times-circle"
              title="nie wszystko na raz"
            />
          </BlockContent>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
